module.exports = __webpack_public_path__ + "static/media/landingPage.0dc6dcd6.png";